/*
 * eslint-disable -- o AppLink ja encapsula WLink.
 */
/* eslint-disable @alice-health/w-link */

import Image from 'next/image'
import { Link } from '@/global/components/Link'
import {
  LIST_SOCIAL_ICONS,
  sendButtonClickedAnalyticEvent
} from './Navbar.helpers'

const ICON_SIZE = 16

interface NavbarDrawerSocialProps {
  onNavigate: () => void
}

const NavbarDrawerSocial = ({ onNavigate }: NavbarDrawerSocialProps) => (
  <div
    data-testid='navbar-drawer-social'
    className='flex flex-wrap items-center gap-gl-spacing-06'
  >
    {LIST_SOCIAL_ICONS.map(icon => (
      <div
        key={icon.name}
        className='flex items-center gap-gl-spacing-02'
      >
        {/*
         * O icone fica fora do link, e nao dentro dele como em producao: o
         * `className` do AppLink cai no wrapper, entao um icone irmao do texto
         * dentro do WLink nao teria como ser alinhado em linha. Ele e
         * decorativo e o link ao lado carrega o nome da rede, entao o `alt`
         * vazio mantem a arvore de acessibilidade limpa.
         */}
        <Image
          width={ICON_SIZE}
          height={ICON_SIZE}
          className='h-[16px] w-[16px]'
          /*
           * Variante `-black`: o painel do menu e branco. O arquivo sem
           * sufixo e a versao clara, para fundo escuro.
           */
          src={`/images/socials/${icon.name}-black.png`}
          alt=''
        />

        <Link
          as='link'
          quiet
          variant='primary'
          size='small'
          href={icon.url}
          target='_blank'
          onClick={() => {
            sendButtonClickedAnalyticEvent(icon.label)
            onNavigate()
          }}
        >
          {icon.label}
        </Link>
      </div>
    ))}
  </div>
)

export { NavbarDrawerSocial }
